module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Applications_05-52f499495ce120468c19bb717036eae9.jpg";